export type ToolbarPlacement = 'off' | 'header' | 'footer';

export const TOOLBAR_PLACEMENTS: ToolbarPlacement[] = ['off', 'header', 'footer'];
